import {
  SlDrawer,
  SlTooltip,
  SlIcon,
  SlSelect,
  SlOption,
  SlTabGroup,
  SlTab,
  SlTabPanel,
  SlDetails,
} from "@shoelace-style/shoelace/dist/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import { roles } from "../../utils/constants";
import { formatDate, formatDateWithTime } from "../../utils/dateFormat";
import Paginator from "../../shared/Paginator";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router";
import Datepicker from "react-tailwindcss-datepicker";

const TYPE_META = {
  1: { label: "Category", icon: "tag", cls: "bg-violet-50 text-violet-700" },
  2: { label: "Location", icon: "map-pin", cls: "bg-blue-50 text-blue-700" },
  3: { label: "Brand Merging", icon: "git-merge", cls: "bg-teal-50 text-teal-700" },
  4: { label: "Pricing", icon: "indian-rupee", cls: "bg-amber-50 text-amber-700" },
  5: { label: "Ad Type", icon: "layout-template", cls: "bg-fuchsia-50 text-fuchsia-700" },
  6: { label: "Page", icon: "file-text", cls: "bg-slate-100 text-slate-600" },
};
const STATUS_META = {
  1: { label: "Pending", cls: "bg-amber-50 text-amber-700" },
  2: { label: "In Progress", cls: "bg-blue-50 text-blue-700" },
  3: { label: "Resolved", cls: "bg-green-50 text-green-700" },
  4: { label: "Ignore", cls: "bg-slate-100 text-slate-500" },
};
const AVATAR_COLORS = ["#5b6ee8", "#0f9d8f", "#c2551f", "#8a4fbf", "#b3345a", "#1967d2", "#2e7d32", "#a56a00"];
const CLAMP3 = { display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" };
const PER_PAGE = 50;

const typeMeta = (type) => TYPE_META[type] || { label: "Other", icon: "tag", cls: "bg-slate-100 text-slate-600" };
const statusMeta = (status) => STATUS_META[status] || { label: "-", cls: "bg-slate-100 text-slate-500" };
const getInitials = (name) =>
  ((name || "").replace(/[^a-zA-Z0-9 ]/g, "").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("") || "U").toUpperCase();
const avatarColor = (s) => {
  s = s || "";
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) & 0xffffffff;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
};

function Help() {
  const navigate = useNavigate();

  const form2 = useForm({
    mode: "onSubmit",
  });
  const form3 = useForm({
    mode: "onSubmit",
  });
  const form4 = useForm({
    mode: "onSubmit",
  });

  const watchUpdate = form2.watch("description");
  const watchReason = form3.watch("update");
  const watchBulkUpdate = form4.watch("description");
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const defaultDateRange = useMemo(() => {
    const formatDateInput = (date) => date.toISOString().split("T")[0];
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 6);
    return {
      startDate: formatDateInput(start),
      endDate: formatDateInput(end),
    };
  }, []);
  const [loader, setLoader] = useState(false);
  const [currentpage, setCurrentPage] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [previewMedia, setPreviewMedia] = useState(null);
  const [data, setData] = useState([]);
  const [preview, setPreview] = useState(false);
  const [helpData, setHelpData] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [showUpdates, setShowUpdates] = useState(false);
  const [updates, setUpdates] = useState([]);
  const [status, setStatus] = useState("all");
  const [type, setType] = useState("all");
  const [totalPages, setTotalPages] = useState(0);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [activeTab, setActiveTab] = useState("all");
  const [dateRange, setDateRange] = useState(defaultDateRange);
  const [dateWiseReport, setDatewiseReport] = useState([]);
  const [copiedImageId, setCopiedImageId] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkUpdate, setBulkUpdate] = useState(false);
  const copyResetTimer = useRef(null);
  const role = localStorage.getItem("role");
  const dateWiseTotals = useMemo(
    () =>
      dateWiseReport.reduce(
        (acc, report) => ({
          pending: acc.pending + (Number(report.pending) || 0),
          progress: acc.progress + (Number(report.progress) || 0),
          resolved: acc.resolved + (Number(report.resolved) || 0),
          ignore: acc.ignore + (Number(report.ignore) || 0),
          total: acc.total + (Number(report.total) || 0),
        }),
        { pending: 0, progress: 0, resolved: 0, ignore: 0, total: 0 }
      ),
    [dateWiseReport]
  );
  const selectableIds = useMemo(() => data.map((item) => item.id), [data]);
  const allSelected =
    selectableIds.length > 0 && selectableIds.every((id) => selectedIds.includes(id));
  const toggleSelect = (id) =>
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  const toggleSelectAll = () => setSelectedIds(allSelected ? [] : selectableIds);

  const statusMappings = {
    1: "Pending",
    2: "In Progress",
    3: "Resolved",
    4: "Ignore",
  };

  useEffect(() => {
    return () => {
      if (copyResetTimer.current) clearTimeout(copyResetTimer.current);
    };
  }, []);

  const loadData = async (page = currentpage) => {
    if(activeTab === 'dateWise') return
    setLoader(true);
    try {
      let res = await API({
        url: "/help/get",
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: PER_PAGE,
          status,
          type,
          ...(dateRange?.startDate &&
            dateRange?.endDate && {
              start_date: dateRange.startDate,
              end_date: dateRange.endDate,
            }),
        },
      });
      if (res.code === 200) {
        setData(res.data?.data);
        setSelectedIds([]);
        setTotalPages(Math.ceil(res.data?.totals / PER_PAGE));
        setCurrentPage(page);
      } else if (res.code === 401) navigate("/");
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  const handlePreview = (url) => {
    const type = url.split(".")?.pop();
    setPreviewMedia({
      url: url,
      type: type === "mp4" ? "video" : "image",
    });
    setPreview(true);
  };
  const handleUpdateHelp = async (data) => {
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/update",
        method: "POST",
        responseType: "json",
        data: {
          id: helpData.id,
          status: data.status,
          update: data.description,
          data: helpData,
        },
      });
      if (res.code === 200) {
        setUpdateStatus(false);
        setHelpData(null);
        loadData();
        form2.reset();
      }
    } catch (error) {
    } finally {
      setSubmitLoader(false);
    }
  };
  const handleIgnore = async (data) => {
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/ignore",
        method: "POST",
        responseType: "json",
        data: {
          id: deleteId,
          update: data.update,
          status: 4,
        },
      });
      if (res.code === 200) {
        loadData();
        setDeleteClicked(false);
        setDeleteId(null);
        form3.reset();
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Someting went wrong");
    } finally {
      setSubmitLoader(false);
    }
  };

  const handleBulkUpdate = async (formData) => {
    const items = data.filter((item) => selectedIds.includes(item.id));
    if (!items.length) return;
    setSubmitLoader(true);
    try {
      const results = await Promise.all(
        items.map((item) =>
          API({
            url: "/help/update",
            method: "POST",
            responseType: "json",
            data: {
              id: item.id,
              status: formData.status,
              update: formData.description,
              data: item,
            },
          }).catch(() => null)
        )
      );
      const failed = results.filter((res) => res?.code !== 200).length;
      if (failed === items.length) {
        Toast("error", "Someting went wrong");
        return;
      }
      if (failed) Toast("error", `${failed} of ${items.length} issues could not be updated`);
      else Toast("success", `${items.length} issues updated`);
      loadData();
      setBulkUpdate(false);
      setSelectedIds([]);
      form4.reset();
    } catch (error) {
      console.error(error);
      Toast("error", "Someting went wrong");
    } finally {
      setSubmitLoader(false);
    }
  };

  const handleCopyImage = async (url, key) => {
    try {
      await navigator.clipboard.writeText(url || "");
      setCopiedImageId(key);
      if (copyResetTimer.current) clearTimeout(copyResetTimer.current);
      copyResetTimer.current = setTimeout(() => setCopiedImageId(null), 2000);
    } catch (error) {
      Toast("error", "Failed to copy");
    }
  };
  useEffect(() => {
    setSelectedIds([]);
    loadData(0);
    setCurrentPage(0)
  }, [status, type, activeTab]);

  useEffect(() => {
    loadData(0);
    setCurrentPage(0)
  }, [dateRange?.startDate, dateRange?.endDate]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(event.selected);
  };

  const loadDateWise = async()=>{
    setLoader(true)
    try {
      let res = await API({
        url:'/help/datewise',
        method:'POST',
        responseType:'json',
        data:{
            dateRange
        }
      })
      if(res.code === 200){
        setDatewiseReport(res.data)
      }
    } catch (error) {
      console.error(error, "Error at loadDatewise")
    }finally{
      setLoader(false)
    }
  }

  useEffect(()=>{
    if(activeTab === 'dateWise'){
      loadDateWise()
    }
  },[activeTab, dateRange])

  const PageRateDetails = ({ item }) => {
    if (item?.record_type !== "PageRates") return null;
    return (
      <div className="flex flex-col gap-1 text-sm leading-5">
        <p>NewsPaper : {item?.newspaper_name?.toUpperCase() || "-"}</p>
        <p>LocationType : {item?.location_type?.toUpperCase() || "-"}</p>
        <p>Location: {item?.location?.toUpperCase() || "-"}</p>
        <p>Page Type: {item?.page_type?.toUpperCase() || "-"}</p>
        <p>Ad Type: {item?.ad_type?.toUpperCase() || "-"}</p>
        <p>AdSize: {item?.ad_size?.toUpperCase() || "-"}</p>
        <p>Color Price: {item?.price || "-"}</p>
        <p>BW Price: {item?.bw_price || "-"}</p>
      </div>
    );
  };
  return (
    <>
      <h4 className="mb-2 mt-1 text-xl font-semibold text-slate-800">Tickets</h4>
      <SlTabGroup
        className="mt-3"
        onSlTabShow={(event) => {
          setActiveTab(event.detail.name);
          setCurrentPage(0);
        }}
      >
        <SlTab slot="nav" panel="all">
          All issues
        </SlTab>
        <SlTab slot="nav" panel="dateWise">
          Date wise
        </SlTab>

        <SlTabPanel name="all">
          {/* Filters */}
          <div className="mb-3 mt-2 flex flex-wrap items-end gap-3 rounded-xl border border-slate-200 bg-white p-3">
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-slate-500">Date range</label>
              <Datepicker
                value={dateRange}
                onChange={(val) => setDateRange(val || defaultDateRange)}
                useRange
                asSingle={false}
                primaryColor="indigo"
                popoverDirection="down"
                readOnly={false}
                showShortcuts={true}
                toggleClassName="hidden"
                containerClassName="w-full relative min-w-[240px]"
                inputClassName="form-control"
                displayFormat="DD/MM/YYYY"
              />
            </div>
            <div className="w-40">
              <label className="mb-1 block text-xs font-medium text-slate-500">Type</label>
              <SlSelect className="w-full" value={type} onSlChange={(e) => setType(e.target.value)} size="medium">
                <SlOption value="all">All</SlOption>
                <SlOption value={1}>Category</SlOption>
                <SlOption value={2}>Location</SlOption>
                <SlOption value={3}>Brand Merging</SlOption>
                <SlOption value={4}>Pricing</SlOption>
                <SlOption value={5}>Ad Type</SlOption>
                <SlOption value={6}>Page</SlOption>
              </SlSelect>
            </div>
            <div className="w-40">
              <label className="mb-1 block text-xs font-medium text-slate-500">Status</label>
              <SlSelect className="w-full" value={status} onSlChange={(e) => setStatus(e.target.value)} size="medium">
                <SlOption value="all">All</SlOption>
                <SlOption value={1}>Pending</SlOption>
                <SlOption value={2}>In Progress</SlOption>
                <SlOption value={3}>Resolved</SlOption>
                <SlOption value={4}>Ignore</SlOption>
              </SlSelect>
            </div>
          </div>

          {role === roles.b2b && selectableIds.length > 0 && !loader ? (
            <div className="mb-3 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2">
              <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-slate-600">
                <input
                  type="checkbox"
                  className="h-4 w-4 cursor-pointer accent-[#4952FA]"
                  checked={allSelected}
                  onChange={toggleSelectAll}
                />
                Select all on this page
                {selectedIds.length > 0 ? (
                  <span className="rounded-full bg-[#E5EBFF] px-2 py-0.5 text-[11px] font-semibold text-[#4952FA]">
                    {selectedIds.length} selected
                  </span>
                ) : null}
              </label>
              {selectedIds.length > 0 ? (
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-2.5 py-1 text-xs font-medium text-slate-500 hover:bg-slate-50"
                    onClick={() => setSelectedIds([])}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-lg bg-[#E5EBFF] px-2.5 py-1 text-xs font-semibold text-[#4952FA] hover:bg-[#d5ddff]"
                    onClick={() => setBulkUpdate(true)}
                  >
                    <SlIcon library="lucide" name="edit" className="h-3.5 w-3.5" />
                    Update selected ({selectedIds.length})
                  </button>
                </div>
              ) : null}
            </div>
          ) : null}

          {loader ? (
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="h-52 animate-pulse rounded-xl border border-slate-200 bg-slate-50" />
              ))}
            </div>
          ) : data.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 text-slate-400">
              <SlIcon library="lucide" name="ticket" className="h-11 w-11 text-slate-300" />
              <p className="mt-3 text-sm font-medium text-slate-500">No tickets match your filters</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {data.map((item, index) => {
                const tm = typeMeta(item.type);
                const sm = statusMeta(item.status);
                const copyKey = item.id ?? index;
                const selectable = role === roles.b2b;
                const isSelected = selectedIds.includes(item.id);
                return (
                  <div
                    key={copyKey}
                    className={`flex flex-col gap-2 rounded-xl border bg-white p-3 transition-shadow hover:shadow-md ${
                      isSelected ? "border-[#4952FA] ring-1 ring-[#4952FA]" : "border-slate-200"
                    }`}
                  >
                    <div className="flex items-center justify-between gap-2">
                      <span className="inline-flex items-center gap-1.5">
                        {selectable ? (
                          <input
                            type="checkbox"
                            className="h-4 w-4 cursor-pointer accent-[#4952FA]"
                            checked={isSelected}
                            onChange={() => toggleSelect(item.id)}
                            title="Select issue"
                          />
                        ) : null}
                        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${tm.cls}`}>
                          <SlIcon library="lucide" name={tm.icon} className="h-3 w-3" />
                          {tm.label}
                        </span>
                      </span>
                      <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${sm.cls}`}>{sm.label}</span>
                    </div>

                    <div>
                      <div className="text-[11px] font-medium text-slate-400">
                        Campaign · #{index + 1}
                        {item.brand_name ? ` · ${item.brand_name}` : ""}
                      </div>
                      <div className="break-words text-sm font-semibold text-slate-800">{item.campaign_name}</div>
                    </div>

                    {item.description ? (
                      <p className="m-0 text-xs leading-5 text-slate-500" style={CLAMP3} title={item.description}>
                        {item.description}
                      </p>
                    ) : null}
                    {item.record_type === "PageRates" ? (
                      <SlDetails summary="Page rate details">
                        <PageRateDetails item={item} />
                      </SlDetails>
                    ) : null}

                    <div className="flex items-end justify-between gap-2">
                      <div className="min-w-0">
                        <div className="text-[10px] uppercase tracking-wide text-slate-400">Ad Published</div>
                        <div className="text-xs font-medium text-slate-700">{formatDate(item.birdview_date)}</div>
                      </div>
                      <div className="min-w-0">
                        <div className="text-[10px] uppercase tracking-wide text-slate-400">Created</div>
                        <div className="text-xs font-medium text-slate-700">{formatDate(item.created_on)}</div>
                      </div>
                      <button
                        type="button"
                        onClick={() => handleCopyImage(item.image_url, copyKey)}
                        className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-[#E5EBFF] px-2.5 py-1 text-xs font-medium text-[#4952FA] transition-colors hover:bg-[#d5ddff]"
                      >
                        <SlIcon library="lucide" name={copiedImageId === copyKey ? "check" : "copy"} className="h-3.5 w-3.5" />
                        {copiedImageId === copyKey ? "Copied" : "Copy URL"}
                      </button>
                    </div>

                    <div className="mt-auto flex items-center justify-between gap-2 border-t border-slate-100 pt-2">
                      <div className="flex min-w-0 items-center gap-2">
                        <span
                          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold text-white"
                          style={{ background: avatarColor(item.name) }}
                        >
                          {getInitials(item.name)}
                        </span>
                        <span className="truncate text-xs text-slate-500" title={item.name}>{item.name}</span>
                      </div>
                      <div className="flex shrink-0 items-center gap-2 text-slate-500">
                        <SlTooltip content="Preview">
                          <SlIcon
                            library="lucide"
                            name="eye"
                            className="h-4 w-4 cursor-pointer hover:text-[#4952FA]"
                            onClick={() => handlePreview(item.media_url || item.image_url)}
                          />
                        </SlTooltip>
                        {role === roles.b2b && (
                          <SlTooltip content="Edit">
                            <SlIcon
                              library="lucide"
                              name="edit"
                              className="h-4 w-4 cursor-pointer hover:text-[#4952FA]"
                              onClick={() => {
                                setUpdateStatus(true);
                                form2.setValue("status", item.status);
                                setHelpData(item);
                              }}
                            />
                          </SlTooltip>
                        )}
                        <SlTooltip content="View Updates">
                          <SlIcon
                            library="lucide"
                            name="bell"
                            className="h-4 w-4 cursor-pointer hover:text-[#4952FA]"
                            onClick={() => {
                              setShowUpdates(true);
                              setHelpData(item);
                              setUpdates(item.updates);
                            }}
                          />
                        </SlTooltip>
                        {role === roles.salesperson && item.status !== 3 && item.status !== 4 && (
                          <SlTooltip content="Ignore / Misrepresentation">
                            <SlIcon
                              library="lucide"
                              name="trash-2"
                              className="h-4 w-4 cursor-pointer hover:text-red-500"
                              onClick={() => {
                                setDeleteId(item.id);
                                setDeleteClicked(true);
                              }}
                            />
                          </SlTooltip>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="mt-4 flex justify-end">
            {totalPages > 1 && (
              <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentpage} />
            )}
          </div>
        </SlTabPanel>

        <SlTabPanel name="dateWise">
          <div className="mb-3 mt-2 flex flex-wrap items-end gap-3 rounded-xl border border-slate-200 bg-white p-3">
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-slate-500">Date range</label>
              <Datepicker
                value={dateRange}
                onChange={(val) => setDateRange(val || defaultDateRange)}
                useRange
                asSingle={false}
                primaryColor="indigo"
                popoverDirection="down"
                readOnly={false}
                showShortcuts={true}
                toggleClassName="hidden"
                containerClassName="w-full relative min-w-[240px]"
                inputClassName="form-control"
                displayFormat="DD/MM/YYYY"
              />
            </div>
          </div>

          {loader ? (
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="h-32 animate-pulse rounded-xl border border-slate-200 bg-slate-50" />
              ))}
            </div>
          ) : dateWiseReport.length > 0 ? (
            <>
              {/* Summary */}
              <div className="mb-3 flex flex-wrap items-center gap-4 rounded-xl border border-slate-200 bg-white p-4">
                <div>
                  <div className="text-2xl font-bold leading-none text-slate-800">{dateWiseTotals.total}</div>
                  <div className="mt-1 text-xs font-medium text-slate-400">Total tickets</div>
                </div>
                <div className="flex flex-wrap gap-2">
                  {[
                    { label: "Pending", count: dateWiseTotals.pending, cls: "bg-amber-50 text-amber-700" },
                    { label: "In Progress", count: dateWiseTotals.progress, cls: "bg-blue-50 text-blue-700" },
                    { label: "Resolved", count: dateWiseTotals.resolved, cls: "bg-green-50 text-green-700" },
                    { label: "Ignored", count: dateWiseTotals.ignore, cls: "bg-slate-100 text-slate-500" },
                  ].map((c) => (
                    <div
                      key={c.label}
                      className={`flex items-center gap-1.5 rounded-full px-3 py-1 ${c.count > 0 ? c.cls : "bg-slate-50 text-slate-300"}`}
                    >
                      <span className="text-sm font-bold">{c.count}</span>
                      <span className="text-xs font-medium">{c.label}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Per-date cards */}
              <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {dateWiseReport.map((report, idx) => {
                  const cells = [
                    { label: "Pending", count: Number(report.pending) || 0, cls: "bg-amber-50 text-amber-700" },
                    { label: "In Progress", count: Number(report.progress) || 0, cls: "bg-blue-50 text-blue-700" },
                    { label: "Resolved", count: Number(report.resolved) || 0, cls: "bg-green-50 text-green-700" },
                    { label: "Ignored", count: Number(report.ignore) || 0, cls: "bg-slate-100 text-slate-500" },
                  ];
                  return (
                    <div key={idx} className="flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-3">
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2">
                          <SlIcon library="lucide" name="calendar" className="h-4 w-4 text-slate-400" />
                          <span className="text-sm font-semibold text-slate-800">{report.date}</span>
                        </div>
                        <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600">
                          {report.total} total
                        </span>
                      </div>
                      <div className="grid grid-cols-2 gap-2">
                        {cells.map((c) => (
                          <div
                            key={c.label}
                            className={`flex items-center justify-between rounded-lg px-2.5 py-1.5 ${c.count > 0 ? c.cls : "bg-slate-50 text-slate-300"}`}
                          >
                            <span className="text-xs font-medium">{c.label}</span>
                            <span className="text-sm font-bold">{c.count}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center justify-center py-16 text-slate-400">
              <SlIcon library="lucide" name="calendar-x" className="h-11 w-11 text-slate-300" />
              <p className="mt-3 text-sm font-medium text-slate-500">No tickets in this date range</p>
            </div>
          )}
        </SlTabPanel>
      </SlTabGroup>

      {preview && (
        <SlDrawer
          label="preview"
          onSlRequestClose={handleRequestClose}
          open={preview}
          onSlAfterHide={() => {
            setPreview(false);
            setPreviewMedia(null);
          }}
        >
          {previewMedia ? (
            previewMedia.type === "image" ? (
              <img
                src={previewMedia.url}
                alt="Preview"
                className="w-full max-h-96 rounded border"
              />
            ) : (
              <video
                src={previewMedia.url}
                controls
                className="w-full h-auto rounded border"
              />
            )
          ) : (
            <p className="text-gray-500">No media selected</p>
          )}
        </SlDrawer>
      )}
      {updateStatus && (
        <SlDrawer
          label="Update"
          open={updateStatus}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setHelpData(null);
            setUpdateStatus(false);
            form2.reset();
          }}
          style={{'--size':"50vw"}}
        >
          <div className="flex gap-3">
            <div className="w-1/2">
              <img src={helpData.image_url} alt="ad-image" />
              <h5>{helpData.campaign_name}</h5>
              <p>Date : {formatDate(helpData.birdview_date)}</p>
            </div>
          <form className="w-1/2" onSubmit={form2.handleSubmit(handleUpdateHelp)}>
            <div className="mb-3">
              <label className="form-label font-semibold" htmlFor="description">
                Description
              </label>
              <p>{helpData?.description}</p>
              {helpData?.record_type === "PageRates" ? (
                <div className="mt-2">
                  <PageRateDetails item={helpData} />
                </div>
              ) : null}
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="Status">
                Status
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                {...form2.register("status", { required: true })}
              >
                <option value="1">Pending</option>
                <option value="2">In Progress</option>
                <option value="3">Resolved</option>
                <option value="4">Ignore</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="update">
                Update
              </label>
              <span className="text-red-600">*</span>&nbsp;&nbsp;{" "}
              <span
                className={`${
                  watchUpdate?.length > 100 ? "text-red-600" : "text-green-500"
                }`}
              >
                {100 - watchUpdate?.length || 100}
              </span>
              <textarea
                className="form-control"
                id="update"
                rows="3"
                {...form2.register("description", {
                  required: true,
                  minLength: 1,
                  maxLength: 100,
                })}
              ></textarea>
              {form2.formState?.errors?.description?.type === "maxLength" && (
                <p className="text-red-600">Too many Characthers</p>
              )}
              {form2.formState?.errors?.description
                ? form2.formState?.errors?.description?.type !==
                    "maxLength" && (
                    <p className="text-red-600">Please Enter Update</p>
                  )
                : null}
            </div>
            <div className="mb-3">
              <button className="btn btn-primary w-full" type="submit">
                {submitLoader && (
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {submitLoader ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
          </div>
        </SlDrawer>
      )}

      {showUpdates && (
        <SlDrawer
          label="Updates"
          onSlRequestClose={handleRequestClose}
          open={showUpdates}
          onSlAfterHide={() => {
            setShowUpdates(false);
          }}
        >
          <>
            <div className="flex flex-col gap-3">
              <div className="max-w-md p-4 border rounded-lg shadow-lg bg-white">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-medium text-gray-600">
                    {formatDateWithTime(helpData.created_on)}
                  </span>
                  <span
                    className={`px-3 py-1 text-xs font-bold rounded-full 
                     bg-yellow-300 text-black`}
                  >
                    Pending
                  </span>
                </div>

                <p className="text-sm text-gray-500 mb-3">
                  👤 Created By:{" "}
                  <span className="font-medium text-gray-700">
                    {helpData.name}
                  </span>
                </p>
                <p className="text-gray-700">{helpData.description}</p>
              </div>
            </div>
            {updates?.map((update) => (
              <div className="flex flex-col gap-3">
                <div className="max-w-md p-4 border rounded-lg shadow-lg bg-white">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-sm font-medium text-gray-600">
                      {formatDateWithTime(update.updated_on)}
                    </span>
                    <span
                      className={`px-3 py-1 text-xs font-bold rounded-full 
                     ${
                       update.status === "1"
                         ? "bg-yellow-300 text-black"
                         : update.status === "2"
                         ? "bg-blue-300 !text-blue-800"
                         : update.status === "3"
                         ? "bg-green-300 !text-green-900"
                         : "bg-gray-400 !text-gray-800"
                     }`}
                    >
                      {statusMappings[update.status]}
                    </span>
                  </div>

                  <p className="text-sm text-gray-500 mb-3">
                    👤 Updated By:{" "}
                    <span className="font-medium text-gray-700">
                      {update.updated_by}
                    </span>
                  </p>
                  <p className="text-gray-700">{update.update}</p>
                </div>
              </div>
            ))}
          </>
        </SlDrawer>
      )}
      {bulkUpdate && (
        <Modal
          show={bulkUpdate}
          backdrop="static"
          animation={false}
          centered
          onHide={() => {
            setBulkUpdate(false);
            form4.reset();
          }}
        >
          <ModalHeader closeButton>
            <ModalTitle>Update {selectedIds.length} selected issue{selectedIds.length > 1 ? "s" : ""}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <form onSubmit={form4.handleSubmit(handleBulkUpdate)}>
              <div className="mb-3">
                <label className="form-label" htmlFor="bulk-status">
                  Status
                </label>
                <select
                  className="form-select"
                  id="bulk-status"
                  {...form4.register("status", { required: true })}
                >
                  <option value="1">Pending</option>
                  <option value="2">In Progress</option>
                  <option value="3">Resolved</option>
                  <option value="4">Ignore</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="bulk-update">
                  Update
                </label>
                <span className="text-red-600">*</span>&nbsp;&nbsp;
                <span className={`${watchBulkUpdate?.length > 100 ? "text-red-600" : "text-green-500"}`}>
                  {100 - watchBulkUpdate?.length || 100}
                </span>
                <textarea
                  className="form-control"
                  id="bulk-update"
                  rows="3"
                  {...form4.register("description", {
                    required: true,
                    minLength: 1,
                    maxLength: 100,
                  })}
                ></textarea>
                {form4.formState?.errors?.description?.type === "maxLength" && (
                  <p className="text-red-600">Too many Characthers</p>
                )}
                {form4.formState?.errors?.description
                  ? form4.formState?.errors?.description?.type !== "maxLength" && (
                      <p className="text-red-600">Please Enter Update</p>
                    )
                  : null}
                <p className="mt-1 text-xs text-slate-500">
                  This status and update will be applied to all {selectedIds.length} selected issue
                  {selectedIds.length > 1 ? "s" : ""}.
                </p>
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-full" disabled={submitLoader}>
                  {submitLoader && (
                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  )}
                  {submitLoader ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </ModalBody>
        </Modal>
      )}

      {deleteClicked && (
        <Modal
          show={deleteClicked}
          backdrop="static"
          animation={false}
          centered
          onHide={() => {
            setDeleteClicked(false);
            setDeleteId(null);
            form3.reset();
          }}
        >
          <ModalHeader closeButton>
            <ModalTitle>Ignore the issue / Misrepresentation</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <form onSubmit={form3.handleSubmit(handleIgnore)}>
              <div className="mb-3">
                <label htmlFor="update" className="form-label">
                  Reason
                </label>
                <span className="text-red-600">*</span>&nbsp;&nbsp;
                <span
                  className={`${
                    watchReason?.length > 100
                      ? "text-red-600"
                      : "text-green-500"
                  }`}
                >
                  {100 - watchReason?.length || 100}
                </span>
                <textarea
                  className="form-control"
                  rows={2}
                  {...form3.register("update", {
                    required: true,
                    minLength: 1,
                    maxLength: 100,
                  })}
                ></textarea>
                {form3.formState?.errors?.update?.type === "maxLength" && (
                  <p className="text-red-600">Too many Characthers</p>
                )}
                {form3.formState?.errors?.update
                  ? form3.formState?.errors?.update?.type !== "maxLength" && (
                      <p className="text-red-600">Reason is required</p>
                    )
                  : null}
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-full">
                  {submitLoader && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {submitLoader ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

export default Help;
